import { useEffect } from "react"
import { useLocation } from "react-router-dom"

// Declarative <Routes> has no automatic scroll restoration.
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
